import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelect from '../../ReactSelect/ReactSelect';
import ExperienceChart from './ExperienceChart';
import { FormGroup, Input } from 'ps-design';

const EXPERIENCE_NOTES_LAB =
  ' Enter the expected years of experience for a person in this career path. Use the Years Experience Chart to inform your answer.';
const EXPERIENCE_NOTES_MP =
  'Choose the years of experience typical for someone at full proficiency for this role. Use the Years Experience Chart to the right to guide your answer.';

export default class Experience extends Component {
  static propTypes = {
    careerLevels: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string
      })
    ),
    saveJobAndUpdatePay: PropTypes.func,
    saveCareerLevel: PropTypes.func,
    suggestCareer: PropTypes.arrayOf(PropTypes.string),
    display: PropTypes.bool,
    yearsExperience: PropTypes.number,
    yearsMinimum: PropTypes.number,
    careerLevel: PropTypes.string,
    orgJobTitle: PropTypes.string,
    jobCode: PropTypes.string,
    workLocationExact: PropTypes.string,
    orgJobId: PropTypes.number,
    yearsExperienceReport: PropTypes.arrayOf(
      PropTypes.shape({
        actual: PropTypes.number,
        target: PropTypes.number,
        yearsExperience: PropTypes.number,
        experience: PropTypes.number
      })
    ),
    showYearsExperienceLabelUpdate: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      years_experience: this.props.yearsExperience,
      years_minimum: this.props.yearsMinimum,
      careerLevel: this.props.careerLevel
    };
    this.newState = {};
  }

  yearsExperienceChange = (field, event) => {
    if (event && event != '') {
      if (event >= 0) {
        this.newState.yearsExperienceValid = null;
        this.setState({ years_experience: event });
      } else {
        this.newState.yearsExperienceValid = 'error';
      }
    } else {
      this.newState.yearsExperienceValid = 'error';
      this.setState({ years_experience: '' });
    }
  };

  saveUpdateReportExperience(jobDetails) {
    this.props.saveJobAndUpdatePay(
      {
        orgJobTitle: this.props.orgJobTitle,
        orgJobCode: this.props.jobCode,
        workLocation: this.props.workLocationExact,
        orgJobId: this.props.orgJobId,
        jobDetails: jobDetails
      },
      {
        YearsExperience: jobDetails.YearsExperience
      }
    );
  }

  onBlurYearsExperience() {
    if (this.state.years_experience === this.props.yearsExperience) {
      return;
    }

    const jobDetails = { YearsExperience: this.state.years_experience };
    this.saveUpdateReportExperience(jobDetails);
  }

  yearsMinChange = (field, event) => {
    if (event && event != '') {
      if (event >= 0) {
        this.newState.yearsMinValid = '';
        this.setState({ years_minimum: event });
      } else {
        this.newState.yearsMinValid = 'error';
      }
    } else {
      this.newState.yearsMinValid = 'error';
      this.setState({ years_minimum: '' });
    }
  };

  careerChange(value) {
    const newCareer = value ? value.value : null;
    this.setState({ careerLevel: newCareer });
    this.props.saveCareerLevel({
      career: newCareer,
      suggestionsDisplayed: this.props.suggestCareer
    });
  }

  careerChangeClick(suggestion) {
    this.careerChange({
      value: suggestion,
      label: suggestion
    });
  }

  saveUpdateReportMin(jobDetails) {
    this.props.saveJobAndUpdatePay(
      {
        orgJobTitle: this.props.orgJobTitle,
        orgJobCode: this.props.jobCode,
        workLocation: this.props.workLocationExact,
        orgJobId: this.props.orgJobId,
        jobDetails: jobDetails
      },
      {
        YearsMinimum: jobDetails.YearsMinimum
      }
    );
  }

  onBlurYearsMin() {
    if (this.state.years_minimum === this.props.yearsMinimum) {
      return;
    }

    const jobDetails = { YearsMinimum: this.state.years_minimum };
    this.saveUpdateReportMin(jobDetails);
  }

  getLabel = option => {
    return option.label;
  };

  getValue = option => {
    return option.value;
  };

  render() {
    const {
      display,
      careerLevels,
      suggestCareer,
      yearsExperienceReport,
      showYearsExperienceLabelUpdate,
      isMP
    } = this.props;
    if (display && display !== true) {
      return;
    }
    let fromYearsLabel = 'From';
    let toYearsLabel = 'To';
    if (!showYearsExperienceLabelUpdate) {
      fromYearsLabel = 'Years Experience (in Field/Career)';
      toYearsLabel = 'Years Minimum';
    }

    return (
      <div className="row add-job__jobExperience">
        <div className="col-sm-6 add-job__jobExperience__column">
          {!isMP && (
            <h3 className="add-job__all-headers">
              <i className="add-job__experience-heading-icon icon-gauge" />
              Experience
            </h3>
          )}
          <div className="add-job__experience__container">
            <div className="add-job__experience__instruction">{isMP ? EXPERIENCE_NOTES_MP : EXPERIENCE_NOTES_LAB}</div>
            <FormGroup
              text="Preferred Experience Range"
              labelClassName="add-job__form-headers add-job__experience__form__label"
              className="add-job__experience__form"
            >
              <React.Fragment>
                <FormGroup
                  text={fromYearsLabel}
                  labelClassName="add-job__form-headers"
                  className="col-sm-4 add-job__jobExperience__inputs--yrs-experience add-job__jobExperience__inputs"
                >
                  <Input
                    type="number"
                    value={`${this.state.years_minimum}`}
                    onChange={this.yearsMinChange}
                    onBlur={this.onBlurYearsMin.bind(this)}
                    className="add-job__jobExperience__yrs-min-input"
                  />
                </FormGroup>
                <FormGroup
                  text={toYearsLabel}
                  labelClassName="add-job__form-headers"
                  className="col-sm-4 add-job__jobExperience__inputs jobExperience__inputs-max"
                >
                  <Input
                    type="number"
                    value={`${this.state.years_experience}`}
                    onChange={this.yearsExperienceChange.bind(this)}
                    onBlur={this.onBlurYearsExperience.bind(this)}
                    className="add-job__jobExperience__yrs-max-input"
                  />
                </FormGroup>
              </React.Fragment>
            </FormGroup>
            {careerLevels.length > 0 ? (
              <div>
                <FormGroup
                  text="Career Level"
                  labelClassName="add-job__form-headers"
                  className="col-sm-12 add-job__jobExperience__inputs career-level__input"
                >
                  <ReactSelect
                    className="add-job__jobExperience__dropdown"
                    value={careerLevels.filter(({ value }) => value === this.state.careerLevel)}
                    options={careerLevels}
                    getOptionValue={this.getValue.bind(this)}
                    getOptionLabel={this.getLabel.bind(this)}
                    onChange={this.careerChange.bind(this)}
                    isClearable={true}
                  />
                </FormGroup>
                {/*ToDo: should this hide in MP if there are no suggestion and if career level is cleared/removed save and update job*/}
                <div className="add-job__popular-answers__list-row add-job__popular-answers__list-row--shift col-sm-12">
                  <h6 className="add-job__popular-answers-heading">Suggested:</h6>
                  <div className="add-job__popular-answers">
                    {suggestCareer.map((answer, index) => {
                      return (
                        <span
                          key={index}
                          onClick={this.careerChangeClick.bind(this, answer)}
                          className="add-job__popular-answers__list"
                        >
                          {answer}
                        </span>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <div className="col-sm-6 add-job__experience__chart-container">
          <ExperienceChart yearsExperienceReport={yearsExperienceReport} isMP={isMP} />
        </div>
      </div>
    );
  }
}
